import { getCookie } from 'services/token/helpers'

/**
 * Ověří, že accountId z API odpovídá cookie cs-api-accountid (nastavuje ji BE na doménu .colosseum.eu).
 * Cookie z BE je HttpOnly → z JS ji nepřečteme, expectedId bude vždy prázdné. To není chyba:
 * po vypršení JWT se obnoví přes REFRESH token, getAccount vrátí správné accountId, tady nic neověříme
 * a nepřesměrováváme.
 * Pouze pokud by v nějakém prostředí cookie byla čitelná a hodnota by neseděla (bezpečnostní incident),
 * přesměrujeme na /login, ne na /error – jde o nesoulad identity, uživatel se má znovu přihlásit.
 */
export const checkAccountId = (accountId) => {
    const expectedId = getCookie('cs-api-accountid')
    const empty = !expectedId || expectedId === 'undefined' || String(expectedId).trim() === ''
    if (empty) {
        return
    }
    if (String(accountId) !== String(expectedId)) {
        console.error(`accountId ${accountId} cs-api-accountid ${expectedId} – redirect to /login`)
        window.location.href = '/login'
    }
}
